import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, Chip } from '@mui/material';
import { PATH_DASHBOARD } from 'src/routes/paths';
import EProfile from 'src/pages/profiles/enum';
import { Link } from 'react-router-dom';
import EVisitorManagement from 'src/pages/visitorManagement/enum';
import { haveHasType, caravanType, documentStatus, acceptFinallyStatus, sabtNahayiStatus } from '../../../../../enumeration';
import { fDate, fDateApi } from '../../../../../utils/formatTime';
import Enum from '../../../enum';
import MoreTableItem from '../../../../../components/table/MoreTable/MoreTableItem';
import MoreTable from '../../../../../components/table/MoreTable/index';
import { separateNumberWithComma } from '../../../../../utils/index';
import { PASSPORT_SENDING_STATUS } from 'src/config';

export const tableData = ({ baseRoute }) => [
  {
    key: 'name',
    header: 'نام و نام خانوادگی',

    Component: ({ param }) =>
      param?.client?.name || param?.client?.last_name ? (
        <Link
          to={`${PATH_DASHBOARD.profile.root}${PATH_DASHBOARD.profile.show}/${param.client.id}/${EProfile.enumTab.object.travels.value}/${param.id}&travel=${param?.travel?.id}`}
        >
          <Box sx={{ color: 'grey.900' }}>{`${param?.client?.name || '-'} ${param?.client?.last_name || '-'} ${
            param?.members > 1 ? `(${param?.members})` : ''
          }`}</Box>
        </Link>
      ) : (
        '-'
      ),
  },
  {
    key: 'nationalCode',
    header: 'کدملی',
    Component: ({ param }) => param?.client?.code_melli || '-',
  },
  {
    key: 'phone',
    header: 'تلفن همراه',
    Component: ({ param }) => param?.client?.phone || '-',
  },

  {
    key: 'status',
    header: 'اولویت اعزام',
    filter: {
      lookup: Object.values(acceptFinallyStatus),
      multiple: true,
    },
    Component: ({ param }) => <Chip label={param?.status} color={acceptFinallyStatus[param?.status_num]?.color} />,
  },
  {
    key: 'sabt_nahayi_status',
    header: 'وضعیت ثبت نام نهایی',
    filter: {
      lookup: Object.values(sabtNahayiStatus),
      multiple: true,
    },
    Component: ({ param }) => <Chip label={param?.sabt_nahayi_status} color={sabtNahayiStatus?.[param?.sabt_nahayi_status_num]?.color} />,
  },
  // {
  //   key: 'shenasname_number',
  //   header: 'شماره شناسنامه',
  //   Component: ({ param }) => param?.client?.shenasname_number || '-',
  // },
  {
    key: 'identity_status',
    header: 'مدارک هویتی',
    filter: {
      lookup: Object.values(documentStatus),
    },
    Component: ({ param }) => (
      <Chip
        label={param?.identity_status}
        color={EVisitorManagement.status.object[param?.identity_status_num]?.color}
      />
    ),
  },
  // {
  //   key: 'bank_status',
  //   header: 'امور بانکی',
  //   filter: {
  //     lookup: Object.values(documentStatus),
  //   },
  //   Component: ({ param }) => (
  //     <Chip label={param?.bank_status} color={EVisitorManagement.status.object[param?.bank_status_num]?.color} />
  //   ),
  // },
  {
    key: 'duty_status',
    header: 'نظام وظیفه',
    filter: {
      lookup: Object.values(documentStatus),
    },
    Component: ({ param }) => (
      <Chip label={param?.duty_status} color={EVisitorManagement.status.object[param?.duty_status_num]?.color} />
    ),
  },
  {
      key: 'passport_sending_status',
      header: 'وضعیت تحویل گذرنامه',
      filter: {
        lookup: Object.values(PASSPORT_SENDING_STATUS),
      },
      Component: ({ param }) => (
        <Chip label={param?.passport_sending_status} color={PASSPORT_SENDING_STATUS[param?.passport_sending_status_num]?.color} />
      ),
    },
  // {
  //   key: 'confirm_status',
  //   header: 'تایید نهایی',
  //   filter: {
  //     lookup: Object.values(acceptFinallyStatus),
  //   },
  //   Component: ({ param }) => (
  //     <Chip label={param?.status} color={EVisitorManagement.status.object[param?.status_num]?.color} />
  //   ),
  // },
  // {
  //   key: 'shenasname_number',
  //   header: 'شماره شناسنامه',
  //   Component: ({ param }) => param?.shenasname_number || '-',
  // },
  // {
  //   key: 'id',
  //   header: 'کد شناسایی/ID',
  //   Component: ({ param }) => param?.id || '-',
  // },
];
